module.exports = __webpack_public_path__ + "static/media/Timer 4.9f3a31d6.png";